import { createContext } from 'react'

import { ProfileStorageField } from '../../../constants'

export type AuthContextValue = {
  token: string
} & Record<ProfileStorageField, string>

export const AuthContext = createContext<AuthContextValue | null>(null)
